import styled from 'styled-components';
import { Link as LinkS } from 'react-scroll';

export const HeroContainer = styled.section`
  position: relative;
  background: var(--bg-dark);
  min-height: calc(100vh - var(--nav-h));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  overflow: hidden;

  /* Tinted overlay above the video so the text stays readable
     and the hero keeps its green wash. */
  &:before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    background: radial-gradient(
        900px 520px at 72% 8%,
        rgba(16, 185, 129, 0.28),
        transparent 60%
      ),
      linear-gradient(
        180deg,
        rgba(7, 12, 23, 0.72) 0%,
        rgba(4, 30, 23, 0.82) 100%
      );
    pointer-events: none;
  }
`;

export const HeroBg = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
`;

export const VideoBg = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: var(--bg-dark);
`;

export const HeroInner = styled.div`
  position: relative;
  z-index: 2;
  max-width: 880px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Eyebrow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border-radius: var(--radius-pill);
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  color: var(--on-dark);
  font-size: 0.82rem;
  font-weight: 500;
  letter-spacing: 0.01em;
  margin-bottom: 28px;
`;

export const EyebrowDot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--accent);
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.25);
`;

export const HeroH1 = styled.h1`
  color: #fff;
  font-size: 4rem;
  font-weight: 800;
  letter-spacing: -0.035em;
  max-width: 16ch;
  text-shadow: 0 2px 24px rgba(0, 0, 0, 0.35);

  @media screen and (max-width: 768px) {
    font-size: 2.9rem;
  }

  @media screen and (max-width: 480px) {
    font-size: 2.25rem;
  }
`;

export const Accent = styled.span`
  background: linear-gradient(120deg, #6ee7b7, #10b981);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
`;

export const HeroP = styled.p`
  margin-top: 24px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 1.2rem;
  line-height: 1.6;
  max-width: 620px;

  @media screen and (max-width: 480px) {
    font-size: 1.05rem;
  }
`;

export const HeroBtns = styled.div`
  margin-top: 38px;
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const HeroPrimary = styled(LinkS)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: var(--radius-pill);
  background: var(--accent);
  padding: 14px 26px;
  color: #04221a;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
  box-shadow: 0 10px 30px rgba(16, 185, 129, 0.3);

  &:hover {
    background: #34d399;
    transform: translateY(-2px);
  }
`;

export const HeroGhost = styled(LinkS)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: var(--radius-pill);
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  padding: 14px 26px;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.18s ease, border-color 0.18s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.14);
    border-color: rgba(255, 255, 255, 0.34);
  }
`;

export const HeroMeta = styled.div`
  margin-top: 40px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 8px;
`;
